export const initState = {
	surveyType: '',

	fetchAll: {
		_list: 'init',
		$list: [],

		from: 1,
		total: 0,
		size: 10,
	},

	showItem: {
		_show: 'init',
		selectedItem: null,
	},

	deleteItem: {
		_delete: 'init',
		selectedItem: null,
	},
};

export default initState;
